// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms-module--terms--1i_-H PageMarkdown-module--content--2-NB8"};